import { defineComponent, openBlock, createBlock, unref, createSlots, withCtx, createVNode, createTextVNode, toDisplayString, createElementVNode, renderSlot } from "vue";
import { whenever } from "@vueuse/core";
import { N as NcFormBoxButton } from "./NcFormBoxButton-DIKZK9kp.mjs";
import { N as NcIconSvgWrapper } from "./NcIconSvgWrapper-g8ubWhoz.mjs";
import { u as useCopy } from "./useCopy-PckLYUAU.mjs";
const _hoisted_1 = { class: "hidden-visually" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcFormBoxCopyButton",
  props: {
    label: { default: () => void 0 },
    value: {},
    disabled: { type: Boolean, default: false }
  },
  emits: ["copy"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const { isCopied, copy, icon, altText } = useCopy(() => __props.value);
    whenever(isCopied, () => emit("copy"));
    return (_ctx, _cache) => {
      return openBlock(), createBlock(NcFormBoxButton, {
        disabled: __props.disabled,
        invertedAccent: "",
        onClick: unref(copy)
      }, createSlots({
        description: withCtx(() => [
          createTextVNode(toDisplayString(__props.value), 1)
        ]),
        icon: withCtx(() => [
          createVNode(NcIconSvgWrapper, {
            path: unref(icon),
            inline: ""
          }, null, 8, ["path"])
        ]),
        _: 2
      }, [
        _ctx.$slots.default || __props.label ? {
          name: "default",
          fn: withCtx(() => [
            createElementVNode("span", _hoisted_1, toDisplayString(unref(altText)), 1),
            renderSlot(_ctx.$slots, "default", {}, () => [
              createTextVNode(toDisplayString(__props.label), 1)
            ])
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["disabled", "onClick"]);
    };
  }
});
export {
  _sfc_main as _
};
//# sourceMappingURL=NcFormBoxCopyButton.vue_vue_type_script_setup_true_lang-BVCoU7LB.mjs.map
